import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0b13088"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-b border-gray-200" }
const _hoisted_2 = {
  class: "flex justify-center",
  "aria-label": "Tabs"
}
const _hoisted_3 = ["data-testid", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "mt-8"
}

import { computed, useSlots } from 'vue'

export interface TabItem {
  label: string
  value: string
  testId?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    modelValue: {},
    tabs: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {



const slots = useSlots()
const hasSlots = computed(() => Object.keys(slots).length > 0)



const selectTab = (value: string) => {
  emit('update:modelValue', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tab.value,
            class: _normalizeClass([
            'border-b-2 w-full text-center',
            _ctx.modelValue === tab.value ? 'border-[#2F7F91]' : 'border-transparent'
          ])
          }, [
            _createElementVNode("button", {
              "data-testid": tab.testId,
              onClick: ($event: any) => (selectTab(tab.value)),
              class: _normalizeClass([
              'py-4 px-2 transition-colors focus:outline-none w-full h-full',
              _ctx.modelValue === tab.value
                ? 'text-gray-900 font-bold'
                : 'text-gray-500 hover:text-gray-700'
            ])
            }, _toDisplayString(tab.label), 11, _hoisted_3)
          ], 2))
        }), 128))
      ])
    ]),
    (hasSlots.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("div", { key: _ctx.modelValue }, [
                _renderSlot(_ctx.$slots, _ctx.modelValue)
              ]))
            ]),
            _: 3
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})